export class Sidebar {
  static initialize() {
    const sidebar = document.getElementById('sidebar')
    
    if (sidebar) {
      const toggleSidebarMobile = (
        sidebar,
        sidebarBackdrop,
        toggleSidebarMobileHamburger,
        toggleSidebarMobileClose
      ) => {
        sidebar.classList.toggle('-translate-x-full')
        sidebarBackdrop.classList.toggle('hidden')
        toggleSidebarMobileHamburger.classList.toggle('hidden')
        toggleSidebarMobileClose.classList.toggle('hidden')
      }

      const toggleSidebarMobileEl = document.getElementById('toggleSidebarMobile')
      const sidebarBackdrop = document.getElementById('sidebarBackdrop')
      const toggleSidebarMobileHamburger = document.getElementById('toggleSidebarMobileHamburger')
      const toggleSidebarMobileClose = document.getElementById('toggleSidebarMobileClose')

      if (toggleSidebarMobileEl && sidebarBackdrop && toggleSidebarMobileHamburger && toggleSidebarMobileClose) {
        // Remove existing event listeners to prevent duplicates
        toggleSidebarMobileEl.replaceWith(toggleSidebarMobileEl.cloneNode(true))
        sidebarBackdrop.replaceWith(sidebarBackdrop.cloneNode(true))
        
        // Get fresh references after cloning
        const newToggleSidebarMobileEl = document.getElementById('toggleSidebarMobile')
        const newSidebarBackdrop = document.getElementById('sidebarBackdrop')
        
        newToggleSidebarMobileEl.addEventListener('click', () => {
          toggleSidebarMobile(
            sidebar,
            newSidebarBackdrop,
            toggleSidebarMobileHamburger,
            toggleSidebarMobileClose
          )
        })

        newSidebarBackdrop.addEventListener('click', () => {
          toggleSidebarMobile(
            sidebar,
            newSidebarBackdrop,
            toggleSidebarMobileHamburger,
            toggleSidebarMobileClose
          )
        })
      }
    }
  }
} 